import React, {Component} from 'react';
import EmptyResults from 'app/components/articles/EmptyResults';
import {inject, observer} from 'mobx-react';
import Preview from 'app/components/pages/articles/Preview';
import SmartFullPageLoader from 'app/components/reusable/smart_loaders/SmartFullPageLoader';
import ArticleInterface from 'app/interfaces/articles/ArticleInterface';
import I18n from 'app/i18n';
import {GAMER_2} from 'app/utils/Consts';
import PaginateInterface from 'app/interfaces/articles/PaginateInterface';
import Pagination from 'app/components/pagination';
import {ArticlesStore} from 'app/store/ArticlesStore';
import ParamsDataInterface from 'app/interfaces/articles/ParamsDataInterface';
import {isDesktop, scrollToTop, getLinkPath} from 'app/utils';
import {NavLink} from 'react-router-dom';

interface ArticlesContainerProps {
    category?: string
    articles?: ArticleInterface[]
    loading?: boolean
    slug: string
    type?: string
    paginate?: PaginateInterface
    searchValue?: string
    articlesStore?: ArticlesStore
    containerForMainPage?: boolean
}
interface ArticlesContainerState {
    visibleCount: number;
}

export const NEWS_PER_PAGE = 10;
export const DESKTOP_MAIN_NEWS_PER_PAGE = 2;
export const MOBILE_MAIN_NEWS_PER_PAGE = 4;

@inject('articlesStore')
@observer
export default class ArticlesContainer extends Component<ArticlesContainerProps, ArticlesContainerState> {
    defineVisibleCount = (): number => {
        const {containerForMainPage} = this.props;

        if (containerForMainPage) {
            return isDesktop() ? DESKTOP_MAIN_NEWS_PER_PAGE : MOBILE_MAIN_NEWS_PER_PAGE;
        }
        return NEWS_PER_PAGE;
    };

   state = {
       loading: false,
       visibleCount: this.defineVisibleCount()
   };

  groupedArticles = (articles: ArticleInterface[]): ArticleInterface[][] => {
      const grouped = [];

      for (let i = 0; i < articles.length; i += GAMER_2) {
          grouped.push(articles.slice(i, i + GAMER_2));
      }
      return grouped;
  };

  loadData = (params?: ParamsDataInterface, searchValue = ''): void => {
      const p = {
          ...params,
          category: this.props.category
      };
      this.props.articlesStore.loadData(p, searchValue, this.props.type);
  };


  render(): React.ReactNode {
      const {loading, articles = [], type, paginate, searchValue, slug} = this.props;
      const {visibleCount} = this.state;

      const visibleArticles = articles.slice(0, visibleCount);

      const grouped = this.groupedArticles(visibleArticles);

      const allShown = visibleCount >= articles.length;

      return (
          <>
              {loading
                  ? <SmartFullPageLoader />
                  : <>
                      <div className="content__holder news-wrapper">
                          {visibleArticles.length > 0
                              ? grouped.map((pair, index) => <div key={index} className="article--preview-row">
                                  {pair.map(article => <Preview key={article.id} data={article} type={type || 'news'} />)}
                              </div>)
                              : <EmptyResults />
                          }
                      </div>
                      {!allShown && <div className="news-more">
                          <NavLink to={getLinkPath(`/news/${slug}`)} className="show-more-news" onClick={scrollToTop}>{I18n.t('show_more')}</NavLink>
                      </div>}
                      {paginate && <Pagination {...paginate} searchValue={searchValue} switchPage={this.loadData}/>}
                  </>
              }
          </>
      );
  }
}
